import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fad8d58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resume-dropdown" }
const _hoisted_2 = { class: "custom-select" }
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, "Select a resume to inform your cover letter", -1))
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-down" })
], -1))

import type { ResumeListItem } from "../../../../server/src/models/dtos/ResumesList";


const __default__ = {
  name: "ResumeDropdown",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: {},
    resumes: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

function handleChange(event: Event) {
  const target = event.target as HTMLSelectElement;
  emit("update:modelValue", target.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("select", {
        class: "form-select",
        value: _ctx.modelValue,
        onChange: handleChange
      }, [
        _hoisted_4,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resumes, (resume) => {
          return (_openBlock(), _createElementBlock("option", {
            key: resume.id,
            value: resume.id
          }, _toDisplayString(resume.name), 9, _hoisted_5))
        }), 128))
      ], 40, _hoisted_3),
      _hoisted_6
    ])
  ]))
}
}

})